import { Link } from "react-router-dom";
import { LOGO_URL, BRAND } from "../data/mock";
import { Github, Twitter, Linkedin, Mail } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300 mt-20">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-14 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt={BRAND.name} className="h-10 w-10 bg-white rounded object-contain p-1" />
            <div>
              <div className="font-bold text-white text-lg">{BRAND.name}</div>
              <div className="text-[11px] uppercase tracking-[0.2em] text-emerald-400 font-semibold">{BRAND.tagline}</div>
            </div>
          </div>
          <p className="mt-4 max-w-md text-sm text-stone-400 leading-relaxed">{BRAND.description}</p>
          <div className="flex items-center gap-3 mt-5">
            {[Twitter, Linkedin, Github, Mail].map((Icon, i) => (
              <a key={i} href="#" className="h-9 w-9 rounded-full bg-stone-800 hover:bg-emerald-700 transition-colors flex items-center justify-center">
                <Icon className="h-4 w-4 text-stone-300" />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wide">Product</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/features" className="hover:text-emerald-400">Features</Link></li>
            <li><Link to="/dashboard" className="hover:text-emerald-400">My Maps</Link></li>
            <li><Link to="/pricing" className="hover:text-emerald-400">Pricing</Link></li>
            <li><a href="#" className="hover:text-emerald-400">Map Store</a></li>
          </ul>
        </div>

        <div>
          <h4 className="text-white font-semibold mb-3 text-sm uppercase tracking-wide">Company</h4>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/about" className="hover:text-emerald-400">About</Link></li>
            <li><a href="#" className="hover:text-emerald-400">Careers</a></li>
            <li><a href="#" className="hover:text-emerald-400">Support</a></li>
            <li><a href="#" className="hover:text-emerald-400">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-stone-800">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between text-xs text-stone-500 gap-3">
          <div> {new Date().getFullYear()} {BRAND.name}. All rights reserved.</div>
          <div className="flex gap-5">
            <a href="#" className="hover:text-stone-300">Privacy</a>
            <a href="#" className="hover:text-stone-300">Terms</a>
            <a href="#" className="hover:text-stone-300">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
